import { Link } from 'react-router-dom';

export function RulesPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-primary mb-8">Official Rules</h1>

      <div className="prose prose-lg text-text-dark space-y-6">
        <section>
          <p className="text-lg font-semibold uppercase text-text-light">
            NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT IMPROVE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">1. Sponsor</h2>
          <p>
            All CloudFruit Hunts are sponsored by <strong>Cloudfruit LLC</strong>, Wilmington, NC ("Sponsor").
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">2. Eligibility</h2>
          <p>
            Each Hunt is open to legal residents of the fifty (50) United States and the District of Columbia who are eighteen (18) years of age or older at the time of entry. Employees, officers, and contractors of Sponsor, and their immediate family and household members, are not eligible. Void where prohibited or restricted by law.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">3. Promotion Period</h2>
          <p>
            Each Hunt begins and ends at times announced on the hunt landing page (the "Promotion Period"). Only entries that complete the Hunt during the Promotion Period are eligible for prizes. The Hunt may remain available to play for fun after the Promotion Period ends, but completions after the end time are not prize-eligible. Sponsor's server clock is the official timekeeper.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">4. How to Enter / Play (Free)</h2>
          <p>
            Create a free account at hunt.cloudfruit.com and solve each clue in sequence. Submitting a correct final answer during the Promotion Period constitutes a completed entry. No purchase or payment is required at any point. Limit: one account per person; multiple accounts, automated entry, or use of bots or scripted solvers will result in disqualification.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">5. Prizes</h2>
          <p>
            Each Hunt has its own prize structure, which is announced on the Hunt's landing page before the Promotion Period begins. Common prize types include:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4">
            <li>
              <strong>First Solver Prize</strong> - Awarded to the first eligible entrant to correctly complete all clues during the Promotion Period.
            </li>
            <li>
              <strong>Random Drawing Prizes</strong> - Awarded by random drawing from among all eligible entrants who complete the Hunt during the Promotion Period.
            </li>
          </ul>
          <p className="mt-4">
            Specific prize amounts and details are listed on each Hunt's page. Prizes are non-transferable.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">6. Winner Notification</h2>
          <p>
            Potential winners will be notified by email at the address associated with their account. A potential winner must respond and confirm acceptance within 7 days of notification. Winners may be required to provide additional information (such as a mailing address for prize delivery) and may need to sign an affidavit of eligibility.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">7. Taxes</h2>
          <p>
            All federal, state, and local taxes on any prize are the sole responsibility of the winner. Winners may be required to provide tax information (such as a W-9 form) for prizes exceeding IRS reporting thresholds.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">8. General Conditions</h2>
          <p>
            Sponsor reserves the right to disqualify any entrant who tampers with the entry process, the Hunt, or the website; who uses bots, automation, scripts, or multiple accounts; or who otherwise violates these rules or acts unfairly or in bad faith. Sponsor also reserves the right to cancel, modify, or suspend the Hunt if circumstances beyond its control (technical failures, fraud, etc.) compromise the integrity of the promotion.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">9. Privacy</h2>
          <p>
            Information collected from participants is subject to Sponsor's Privacy Policy. Your email address will be used to notify you if you win and to send occasional updates about future Hunts. You may unsubscribe from marketing emails at any time.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-primary mt-8 mb-4">10. Governing Law</h2>
          <p>
            These rules are governed by the laws of the State of North Carolina, without regard to conflict-of-laws principles.
          </p>
        </section>

        {/* Hunt-Specific Rules Section */}
        <section className="mt-12 pt-8 border-t border-gray-200">
          <h2 className="text-2xl font-bold text-primary mb-6">Hunt-Specific Rules</h2>

          <div className="card mb-6">
            <h3 className="text-lg font-bold text-text-dark mb-3">Hunt #1: The Crane's Riddle</h3>
            <p className="text-text-light mb-4">
              <strong>Promotion Period:</strong> August 1, 2026 - TBD
            </p>
            <p className="mb-4">
              <strong>Prizes:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Grand Prize: $150 USD</strong> - First eligible entrant to complete all clues.
              </li>
              <li>
                <strong>Two Secondary Prizes: $50 USD each</strong> - Random drawing from all completions during the Promotion Period.
              </li>
            </ul>
            <p className="mt-4 text-sm text-text-light">
              Total prize pool: <strong>$250 USD</strong>
            </p>
          </div>

          <p className="text-text-light italic">
            Additional hunts will be announced throughout the year. Check back for updates!
          </p>
        </section>

        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-text-light">
          <p>Void where prohibited. No purchase necessary.</p>
          <p className="mt-2">Cloudfruit LLC</p>
          <p className="mt-4">
            <Link to="/" className="text-primary hover:underline">
              Back to Hunts
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
